module.exports = __webpack_public_path__ + "img/remax-balloon.727de90e.png";